import { render, staticRenderFns } from "./EventsCreate.vue?vue&type=template&id=eb90b3ba&scoped=true"
import script from "./EventsCreate.vue?vue&type=script&lang=js"
export * from "./EventsCreate.vue?vue&type=script&lang=js"
import style0 from "./EventsCreate.vue?vue&type=style&index=0&id=eb90b3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb90b3ba",
  null
  
)

export default component.exports